/** @jsxImportSource @emotion/react */
"use client";
import type { FunctionInterpolation, Interpolation } from "@emotion/react";
import * as RadixUiSeparator from "@radix-ui/react-separator";
import type { ComponentProps } from "react";

import type { ThemeType } from "../../../../../global/emotion";
import {
  numericPercentages,
  numericPixels,
} from "../../../../../global/emotion";

const baseStyle: Interpolation<ThemeType> = (theme) => ({
  backgroundColor: theme.semanticColors.neutralsLowest,
});

const stylesOrientation: Record<
  ComponentProps<typeof RadixUiSeparator.Root>["orientation"],
  FunctionInterpolation<{ size: number }>
> = {
  horizontal: (props) => ({
    height: numericPixels[props.size],
    width: numericPercentages[100],
  }),
  vertical: (props) => ({
    height: numericPercentages[100],
    width: numericPixels[props.size],
  }),
};

export type DividerProps = ComponentProps<typeof RadixUiSeparator.Root> & {
  size?: number;
};

export const Divider = ({
  className,
  orientation = "horizontal",
  size = 1,
  ...props
}: DividerProps) => (
  <RadixUiSeparator.Root
    css={[baseStyle, stylesOrientation[orientation]({ size })]}
    {...props}
  />
);
